"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Badge_1 = require("../../../components/Badge");
var MDIcon_1 = require("../../../components/MDIcon");
var Row_1 = require("../../../components/Row");
var Stack_1 = require("../../../components/Stack");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var R = __importStar(require("../../../utils/ramda"));
var FilterStatusIndicator_1 = require("./FilterStatusIndicator");
var TooltipIcon_1 = require("../../../components/TooltipIcon");
var DataFilterContext_1 = require("../DataFilterContext");
(0, MDIcon_1.preloadIcons)("chevron-down", "chevron-right");
var FilterWrapper = function (_a) {
  var filterId = _a.filterId,
    label = _a.label,
    selectedCount = _a.selectedCount,
    info = _a.info,
    mode = _a.mode,
    isActive = _a.isActive,
    isUnsaved = _a.isUnsaved,
    tooltip = _a.tooltip,
    _b = _a.tooltipColor,
    tooltipColor = _b === void 0 ? "info" : _b,
    _c = _a.tooltipIcon,
    tooltipIcon = _c === void 0 ? "information-outline" : _c,
    tooltipIconColor = _a.tooltipIconColor,
    _d = _a.startExpanded,
    startExpanded = _d === void 0 ? false : _d,
    children = _a.children;
  var _e = __read((0, react_1.useState)(startExpanded), 2),
    expanded = _e[0],
    setExpanded = _e[1];
  var _f = __read((0, react_1.useState)(false), 2),
    tooltipActive = _f[0],
    setTooltipActive = _f[1];
  var translation = (0, react_1.useContext)(DataFilterContext_1.DataFilterContext).translation;
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    gap: "medium-large",
    id: "Filter-".concat(filterId),
    className: (0, classnames_1.default)("vsx-data-filter")
  }, {
    children: [(0, jsx_runtime_1.jsx)(FilterStatusIndicator_1.FilterStatusIndicator, {
      translation: translation,
      isActive: isActive,
      isUnsaved: isUnsaved
    }), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      justify: "space-between",
      style: {
        marginTop: "-12px"
      },
      align: "center",
      onClick: function () {
        return setExpanded(!expanded);
      }
    }, {
      children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        align: "center",
        gap: "medium"
      }, {
        children: [(0, jsx_runtime_1.jsx)("span", __assign({
          className: "vsx-data-filter-label"
        }, {
          children: label
        })), tooltip && (0, jsx_runtime_1.jsx)(TooltipIcon_1.TooltipIcon, {
          content: tooltip,
          icon: tooltipIcon,
          iconColor: tooltipIconColor,
          color: tooltipColor,
          placement: "top",
          active: tooltipActive,
          setActive: setTooltipActive
        })]
      })), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        align: "center"
      }, {
        children: [info, (0, jsx_runtime_1.jsx)(FilterWrapperBage, {
          selectedCount: selectedCount,
          mode: mode
        }), (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
          className: "vsx-data-filter-chevron",
          icon: expanded ? "chevron-down" : "chevron-right"
        })]
      }))]
    })), (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
      gap: "medium-large",
      style: {
        display: !expanded ? "none" : undefined
      }
    }, {
      children: children
    }))]
  }));
};
exports.FilterWrapper = FilterWrapper;
var FilterWrapperBage = function (_a) {
  var selectedCount = _a.selectedCount,
    mode = _a.mode;
  var isBadgeVisible = R.type(selectedCount) === "String" || Number(selectedCount) > 0;
  var text = mode === "custom" ? "".concat(selectedCount, " selected") : "".concat(selectedCount, " ").concat(mode, "d");
  return isBadgeVisible ? (0, jsx_runtime_1.jsx)(Badge_1.Badge, __assign({
    inline: true,
    uppercase: false
  }, {
    children: text
  })) : null;
};